// google-recaptcha.ts
import { VueReCaptcha } from 'vue-recaptcha-v3';

export default defineNuxtPlugin((nuxtApp) => {
    const config = useRuntimeConfig();
    const route = useRoute();
    
    // Add a check for specific pages where you want reCAPTCHA to load
    const shouldLoadRecaptcha = () => {
        const recaptchaPages = ['/iletisim', '/firsatlar'];
        return recaptchaPages.some(path => route.path.includes(path));
    };
    
    // Only initialize reCAPTCHA if we're on a page that needs it
    if (shouldLoadRecaptcha()) {
        nuxtApp.vueApp.use(VueReCaptcha, {
            siteKey: config.public.recaptchaSiteKey as string,
            loaderOptions: {
                autoHideBadge: true,
            },
        });
    }
});